define(['exports', 'react', 'classnames', 'lodash', '../../i18n', '../utils/enums', '../../assets/carat-icon.svg', '../../assets/crown.svg', '../../assets/phone.svg', '../../assets/mail.svg', '../../assets/linked-in.svg', './styles/CandidateReportsView.css'], function (exports, _react, _classnames, _lodash, _i18n, _enums, _caratIcon, _crown, _phone, _mail, _linkedIn) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _i18n2 = _interopRequireDefault(_i18n);

	var enums = _interopRequireWildcard(_enums);

	var _caratIcon2 = _interopRequireDefault(_caratIcon);

	var _crown2 = _interopRequireDefault(_crown);

	var _phone2 = _interopRequireDefault(_phone);

	var _mail2 = _interopRequireDefault(_mail);

	var _linkedIn2 = _interopRequireDefault(_linkedIn);

	function _interopRequireWildcard(obj) {
		if (obj && obj.__esModule) {
			return obj;
		} else {
			var newObj = {};

			if (obj != null) {
				for (var key in obj) {
					if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
				}
			}

			newObj.default = obj;
			return newObj;
		}
	}

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var RECT_BORDER_STYLE = { height: '0.4rem', width: '1.5rem', backgroundColor: 'rgba(103,212,131,0.52)' };

	var CandidateInfoView = function (_Component) {
		_inherits(CandidateInfoView, _Component);

		function CandidateInfoView() {
			_classCallCheck(this, CandidateInfoView);

			return _possibleConstructorReturn(this, (CandidateInfoView.__proto__ || Object.getPrototypeOf(CandidateInfoView)).apply(this, arguments));
		}

		_createClass(CandidateInfoView, [{
			key: 'renderName',
			value: function renderName(name) {
				return _react2.default.createElement(
					'div',
					{ className: 'col-6' },
					_react2.default.createElement(
						'div',
						{ className: 'candidate-name nunito-font' },
						name.toUpperCase()
					),
					_react2.default.createElement('div', { className: 'mt1', style: RECT_BORDER_STYLE })
				);
			}
		}, {
			key: 'renderCriteriaScore',
			value: function renderCriteriaScore() {
				var criteriaScore = this.props.criteriaScore;

				return _react2.default.createElement(
					'div',
					{ className: 'p1 rounded', style: { backgroundColor: '#F5F5F5', border: '1px solid #EEEEEE' } },
					_react2.default.createElement(
						'div',
						{ className: 'clearfix mx3 rounded nunito-font relative color-616161' },
						_react2.default.createElement(
							'div',
							{ className: 'col col-7 font-size-16px', style: { marginTop: '1.4rem' } },
							_i18n2.default.t('dk-ui-lib.reports.profile.criteria_score')
						),
						_react2.default.createElement(
							'div',
							{ className: 'col col-4 clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'clearfix black' },
								_react2.default.createElement(
									'div',
									{ className: 'right-align bold black font-size-32px' },
									criteriaScore
								),
								_react2.default.createElement(
									'div',
									{ className: 'right-align font-size-16px' },
									_i18n2.default.t('dk-ui-lib.reports.carats')
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col col-1 relative',
								style: { left: '1.9rem', marginTop: '1.45rem' }
							},
							_react2.default.createElement(_caratIcon2.default, { height: '2rem', width: '2rem' })
						)
					)
				);
			}
		}, {
			key: 'renderCandidateType',
			value: function renderCandidateType() {
				return _react2.default.createElement(
					'div',
					{ className: 'mt2' },
					_react2.default.createElement(
						'div',
						{ className: 'details-title' },
						enums.candidate_types.FRESHER
					),
					_react2.default.createElement('div', { className: 'mt1', style: RECT_BORDER_STYLE })
				);
			}
		}, {
			key: 'renderRollNo',
			value: function renderRollNo(rollNumber) {
				return _react2.default.createElement(
					'div',
					{ className: 'mt2' },
					_react2.default.createElement(
						'div',
						{ className: 'field-label' },
						_i18n2.default.t('dk-ui-lib.reports.profile.roll_number')
					),
					_react2.default.createElement(
						'div',
						{ className: 'black bold' },
						rollNumber
					)
				);
			}
		}, {
			key: 'renderYearOfPassing',
			value: function renderYearOfPassing(yearOfPassing) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'mt2 field-label' },
						_i18n2.default.t('dk-ui-lib.reports.profile.year_of_passing')
					),
					_react2.default.createElement(
						'div',
						{ className: 'black bold' },
						yearOfPassing
					)
				);
			}
		}, {
			key: 'renderDepartment',
			value: function renderDepartment(department) {
				return _react2.default.createElement(
					'div',
					{ className: 'mt2 field-label', style: { fontSize: '1rem' } },
					department + ' ' + _i18n2.default.t('dk-ui-lib.reports.profile.department')
				);
			}
		}, {
			key: 'renderAcademy',
			value: function renderAcademy(academy) {
				return _react2.default.createElement(
					'div',
					{ className: 'mt2 col-3 field-label', style: { fontSize: '1rem' } },
					academy
				);
			}
		}, {
			key: 'renderCandidateAcademyInfo',
			value: function renderCandidateAcademyInfo() {
				var _props$profile = this.props.profile,
				    rollNumber = _props$profile.rollNumber,
				    yearOfPassing = _props$profile.yearOfPassing,
				    department = _props$profile.department,
				    academy = _props$profile.academy;

				return _react2.default.createElement(
					'div',
					{ className: 'mt4' },
					this.renderCandidateType(),
					this.renderRollNo(rollNumber),
					this.renderYearOfPassing(yearOfPassing),
					this.renderDepartment(department),
					this.renderAcademy(academy)
				);
			}
		}, {
			key: 'renderCandidatePersonalInfo',
			value: function renderCandidatePersonalInfo() {
				var _props$profile2 = this.props.profile,
				    mobile = _props$profile2.mobile,
				    email = _props$profile2.email,
				    social = _props$profile2.social;

				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'mt2 details-title' },
						_i18n2.default.t('dk-ui-lib.reports.personal_info')
					),
					_react2.default.createElement('div', { className: 'mt1', style: RECT_BORDER_STYLE }),
					_react2.default.createElement(
						'div',
						{ className: 'mt2 personal-info-details' },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('mt2', { 'display-none': !mobile }) },
							_react2.default.createElement(
								'span',
								{ className: 'relative mr1', style: { top: '0.2rem' } },
								_react2.default.createElement(_phone2.default, null)
							),
							_react2.default.createElement(
								'span',
								null,
								mobile
							)
						),
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('mt2', { 'display-none': !email }) },
							_react2.default.createElement(
								'span',
								{ className: 'relative mr1', style: { top: '0.2rem' } },
								_react2.default.createElement(_mail2.default, null)
							),
							_react2.default.createElement(
								'span',
								null,
								email
							)
						),
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('mt2', { 'display-none': !(social && social.length) }) },
							_react2.default.createElement(
								'span',
								{ className: 'relative mr1', style: { top: '0.2rem' } },
								_react2.default.createElement(_linkedIn2.default, null)
							),
							_react2.default.createElement('span', null)
						)
					)
				);
			}
		}, {
			key: 'renderSkillLevels',
			value: function renderSkillLevels() {
				var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

				return (levels || []).map(function (level, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'mt1 clearfix skill-level mr1' },
						_react2.default.createElement(
							'div',
							{ className: 'col ml3' },
							_react2.default.createElement(
								'div',
								{ className: 'ml2' },
								_react2.default.createElement(
									'div',
									{ className: 'ml2' },
									_i18n2.default.t('dk-ui-lib.reports.level') + ' ' + level.skillLevel
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'right' },
							level.caratsEarned
						)
					);
				});
			}
		}, {
			key: 'renderSkills',
			value: function renderSkills(skills) {
				var _this2 = this;

				return skills.map(function (skill, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'mt3 border-bottom pb2', style: { borderColor: '#E0E0E0' } },
						_react2.default.createElement(
							'div',
							{ className: 'clearfix relative' },
							_react2.default.createElement(
								'div',
								{ className: 'col col-1' },
								_react2.default.createElement(_crown2.default, null)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col col-5 pl3 skill-name' },
								skill.name.toUpperCase()
							),
							_react2.default.createElement(
								'div',
								{ className: 'col col-5 clearfix skill-carat right-align' },
								skill.carat + ' ' + _i18n2.default.t('dk-ui-lib.reports.carats')
							),
							_react2.default.createElement(
								'div',
								{ className: 'col col-1 center relative border-box',
									style: {
										// width: '3.5rem', 
										// height: '4rem', 
										left: '1.3rem',
										// bottom: '0rem',
										backgroundColor: '#FFF',
										border: '1px solid #E0E0E0' }
								},
								_react2.default.createElement(
									'div',
									{ className: 'mt1' },
									_react2.default.createElement(_caratIcon2.default, { height: '1.5rem', width: '1.5rem' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-10 mx-auto' },
							_this2.renderSkillLevels(skill.levels)
						)
					);
				});
			}
		}, {
			key: 'renderCandidateCaratsInfo',
			value: function renderCandidateCaratsInfo() {
				var _props = this.props,
				    _props$caratSummary = _props.caratSummary,
				    total = _props$caratSummary.total,
				    skills = _props$caratSummary.skills,
				    _props$skillGroups = _props.skillGroups,
				    skillGroups = _props$skillGroups === undefined ? {} : _props$skillGroups;
				var _props$profile3 = this.props.profile,
				    profile = _props$profile3 === undefined ? {} : _props$profile3;

				return _react2.default.createElement(
					'div',
					{ className: '' },
					_react2.default.createElement(
						'div',
						{ className: 'mx3 mt3' },
						_react2.default.createElement(
							'div',
							{ className: 'clearfix nunito-font relative' },
							_react2.default.createElement(
								'div',
								{ className: 'col col-7 color-616161 font-size-24px nunito-font' },
								_i18n2.default.t('dk-ui-lib.reports.overall_earned')
							),
							_react2.default.createElement(
								'div',
								{ className: 'col col-4 clearfix nunito-font' },
								_react2.default.createElement(
									'div',
									{ className: 'flex right' },
									_react2.default.createElement(
										'div',
										{ className: 'clearfix black color-757575 font-size-32px' },
										_react2.default.createElement(
											'div',
											{ className: 'right bold' },
											profile.carats || 0
										),
										_react2.default.createElement(
											'div',
											null,
											_i18n2.default.t('dk-ui-lib.reports.carats')
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{
									className: 'col col-1 relative mt1',
									style: { left: '1rem' }
								},
								_react2.default.createElement(_caratIcon2.default, { height: '3rem', width: '3rem' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('mx3 pt3 border-right', { 'display-none': _lodash2.default.isEmpty(skillGroups) }), style: { borderColor: '#E0E0E0' } },
						this.renderSkillGroups(skillGroups)
					)
				);
			}
		}, {
			key: 'renderSkillGroups',
			value: function renderSkillGroups() {
				var _this3 = this;

				var skillGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


				return _lodash2.default.map(skillGroups, function (skillGroup, skillName) {
					return _react2.default.createElement(
						'div',
						{ className: 'mt3 border-bottom pb2', style: { borderColor: '#E0E0E0' } },
						_react2.default.createElement(
							'div',
							{ className: 'clearfix flex items-center relative' },
							_react2.default.createElement(
								'div',
								{ className: 'col-1' },
								_react2.default.createElement(_crown2.default, null)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-5 pl3 skill-name' },
								skillName
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-5 clearfix skill-carat right-align' },
								_react2.default.createElement(
									'div',
									null,
									skillGroup.caratsEarned
								),
								_react2.default.createElement(
									'div',
									{ className: 'mt1' },
									_i18n2.default.t('dk-ui-lib.reports.carats')
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-1 center relative border-box',
									style: {
										// width: '3.5rem', 
										// height: '4rem', 
										left: '1.3rem',
										// bottom: '0rem',
										backgroundColor: '#FFF',
										border: '1px solid #E0E0E0' }
								},
								_react2.default.createElement(
									'div',
									{ className: 'mt1' },
									_react2.default.createElement(_caratIcon2.default, { height: '1.5rem', width: '1.5rem' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('col-10 mx-auto', { 'display-none': _lodash2.default.isEmpty(skillGroup.SkillSummary) }) },
							_this3.renderSkillLevels(skillGroup.SkillSummary)
						)
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props$profile4 = this.props.profile,
				    profile = _props$profile4 === undefined ? {} : _props$profile4;


				return _react2.default.createElement(
					'div',
					{ className: 'mx4 p3 white-background' },
					_react2.default.createElement(
						'div',
						{ className: 'col-12 flex' },
						_react2.default.createElement(
							'div',
							{ className: 'col-6' },
							this.renderName(profile.firstName),
							this.renderCandidateAcademyInfo(),
							this.renderCandidatePersonalInfo()
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-6' },
							this.renderCriteriaScore(),
							this.renderCandidateCaratsInfo()
						)
					)
				);
			}
		}]);

		return CandidateInfoView;
	}(_react.Component);

	exports.default = CandidateInfoView;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/CandidateInfoView.js
// module id = 1201
// module chunks = 0